import { render, staticRenderFns } from "./Lname.vue?vue&type=template&id=5232a03c"
import script from "./Lname.vue?vue&type=script&lang=js"
export * from "./Lname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports